var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"customCheckbox_main"},on:{"click":_vm.toggle}},[(_vm.checked)?_c('i',{staticClass:"fas fc-main",class:_vm.icon}):_c('i',{staticClass:"far fa-square fc-black"})])}
var staticRenderFns = []

export { render, staticRenderFns }